<template>
    <div>
        <button
            v-bind:class = "['btn-single-toggle',  isRouteDescription ? 'is-active' : '']"
            v-on:click   = "isRouteDescription = !isRouteDescription"
            style="border: 1px solid #dddddd"
        ><i class="material-icons">place</i></button>

        <multiselect
            ref="multiselect"
            v-model="otherServiceTypeSelected"
            v-bind:options="items"
            v-bind:loading="isLoadingItems"
            v-bind:allow-empty="false"
            v-bind:custom-label="serviceLabel"
            placeholder="Zusatzleistung auswählen"
            track-by="id"
            select-label=""
            deselect-label="Löschen"
            :disabled="disabled"
            v-on:search-change = "searchOtherServiceTypes"
            @open="onOpen"
            @close="onClose"
        >
            <template slot="noResult">Keine passenden Leistungsträger</template>

            <template slot="afterList">
                <li v-if="hasMore" class="multiselect__element">
                    <span
                        class="multiselect__option"
                        style="text-align: left; cursor: pointer; color: #3273dc;"
                        @mousedown.prevent
                        @click.stop="loadMore"
                    >{{ isLoadingMore ? '...lade weitere Leistungen...' : 'Mehr Leistungen laden' }}</span>
                </li>
            </template>

            <span slot="caret">
                <a
                    class  = "multiselect-crud-link"
                    href   = "/other_service_types?add"
                    title  = "Füge einen neuen Leistungsträger hinzu"
                    target = "_blank"
                ><i class="material-icons">add</i></a>
            </span>
        </multiselect>
    </div>
</template>



<script>
import axios           from 'axios';
import debounce        from 'lodash/debounce';
import Multiselect     from '@components/form/Multiselect';
import { notifyError } from '@components/Notification';
import {getOtherServiceTypes, getPredefinedRoutesList} from '@api'
import mixins from "@orders/placeholders/components/forms/mixins";
import { settings }   from '@clientSpecific/utilities/settings';


export default {
    mixins: [mixins],
    props: {
        value:           { required: true },
        placeholderInfo: { required: true },
        showServiceDayTimes: {default: false},
        locale: {type: String, required: false},
        initSearch: {type: Boolean, default: false},
        disabled: {type: Boolean, default: false}
    },


    data: function () {
        return {
            otherServiceTypeSelected: null,
            items:                    [],
            queryString:              '',
            isLoadingItems:           false,
            isRouteDescription:       false,
            isOpen:                   false,
            pageSize:                 20,
            itemsPerPage:             20,
            hasMore:                  false,
            isLoadingMore:            false,
            listEl:                   null
        }
    },


    methods: {
        focus () {
            this.$refs.multiselect.focus();
        },

        serviceLabel:  function (otherServiceType) {
            if (this.isRouteDescription) {
                return otherServiceType.routeDescription

            } else {
                return otherServiceType.name;
            }
        },

        onOpen: function () {
            this.isOpen = true;
            if (this.initSearch && this.items.length === 0) {
                this.searchOtherServiceTypes('');
            }
            // Attach an infinite-scroll listener to the dropdown list so more
            // service types are loaded automatically when the user reaches the end.
            this.$nextTick(() => {
                var list = this.$refs.multiselect && this.$refs.multiselect.$refs.list;
                if (list) {
                    this.listEl = list;
                    list.addEventListener('scroll', this.onListScroll);
                }
            });
        },

        onClose: function () {
            this.isOpen = false;
            if (this.listEl) {
                this.listEl.removeEventListener('scroll', this.onListScroll);
                this.listEl = null;
            }
        },

        onListScroll: function (event) {
            var el = event.target;
            if (this.hasMore && !this.isLoadingItems && !this.isLoadingMore
                && (el.scrollTop + el.clientHeight >= el.scrollHeight - 48)) {
                this.loadMore();
            }
        },

        loadMore: function () {
            if (this.isLoadingItems || this.isLoadingMore || !this.hasMore) {
                return;
            }
            this.itemsPerPage += this.pageSize;
            this.runQueries(true);
        },

        searchOtherServiceTypes: debounce(function (query) {
                if (query !== null && (query || this.isOpen)) {
                    this.otherServiceTypeSearch(query, true);
                }

        }, 900),


        otherServiceTypeSearch: function (query, isTriggerAction = false) {
            if (query || isTriggerAction) {
                this.queryString = query;
                this.itemsPerPage = this.pageSize;   // reset paging on every new search / param change
                this.runQueries(false);
            }
        },

        runQueries: function (isLoadMore) {
            if (isLoadMore) {
                this.isLoadingMore = true;
            } else {
                this.isLoadingItems = true;
            }
            this.callCancelRequest();

            var query = this.queryString;

            // Build base params common to all queries
            var baseParams = '?&_itemsPerPage=' + this.itemsPerPage + '&_order[name]=asc';

            if (this.placeholderInfo.category) {
                baseParams += '&category=' + this.placeholderInfo.category;
            }
            if (this.showServiceDayTimes) {
                baseParams += '&_groups[]=other_service_type:service_day_time';
            }
            if (query) {
                baseParams += '&_search=' + query;
            }

            // Build location-specific queries (hierarchical: most specific first)
            var queries = [];

            var useHierarchicalSearch = settings.otherServiceTypes.locationSpecificCategories.includes(this.placeholderInfo.category);

            if (this.placeholderInfo.place) {
                if (useHierarchicalSearch) {
                    var place = this.placeholderInfo.place;
                    var areaId = (this.placeholderInfo.area && this.placeholderInfo.area.id) || (place.area && place.area.id);
                    var destId = (this.placeholderInfo.destination && this.placeholderInfo.destination.id) || (place.area && place.area.destination && place.area.destination.id);
                    queries.push(baseParams + '&place.id=' + place.id);
                    if (areaId) {
                        queries.push(baseParams + '&area.id=' + areaId);
                    }
                    if (destId) {
                        queries.push(baseParams + '&destination.id=' + destId);
                    }
                } else {
                    queries.push(baseParams + '&place.id=' + this.placeholderInfo.place.id);
                }
                queries.push(baseParams + '&area[exists]=false&destination[exists]=false&place[exists]=false');
            } else if (this.placeholderInfo.area) {
                if (useHierarchicalSearch) {
                    var area = this.placeholderInfo.area;
                    var destIdFromArea = (this.placeholderInfo.destination && this.placeholderInfo.destination.id) || (area.destination && area.destination.id);
                    queries.push(baseParams + '&area.id=' + area.id);
                    if (destIdFromArea) {
                        queries.push(baseParams + '&destination.id=' + destIdFromArea);
                    }
                } else {
                    queries.push(baseParams + '&area.id=' + this.placeholderInfo.area.id);
                }
                queries.push(baseParams + '&area[exists]=false&destination[exists]=false&place[exists]=false');
            } else if (this.placeholderInfo.destination) {
                queries.push(baseParams + '&destination.id=' + this.placeholderInfo.destination.id);
                queries.push(baseParams + '&area[exists]=false&destination[exists]=false&place[exists]=false');
            } else {
                // Nothing selected: plain query, no location filters needed
                queries.push(baseParams);
            }

            var requestConfig = {
                cancelToken: this.cancelSource.token,
                headers: {'X-LOCALE': this.locale}
            };

            Promise.all(
                queries.map(function (q) { return getOtherServiceTypes(q, requestConfig); })
            ).then(responses => {
                this.isLoadingItems = false;
                this.isLoadingMore = false;
                // Merge results, deduplicate by id, and sort alphabetically
                var seen = {};
                var merged = [];
                for (var i = 0; i < responses.length; i++) {
                    var data = responses[i].data;
                    for (var j = 0; j < data.length; j++) {
                        if (!seen[data[j].id]) {
                            seen[data[j].id] = true;
                            merged.push(data[j]);
                        }
                    }
                }
                merged.sort(function (a, b) {
                    return (a.name || '').localeCompare(b.name || '');
                });
                this.items = merged;

                // More results may be available if any query branch returned a full page.
                this.hasMore = responses.some(function (r) { return r.data.length >= this.itemsPerPage; }, this);

                if (!isLoadMore && !this.otherServiceTypeSelected && this.items.length > 0) {
                    this.otherServiceTypeSelected = this.items[0];
                }
            }, error => {
                if (!axios.isCancel(error)) {
                    this.isLoadingItems = false;
                    this.isLoadingMore = false;
                    notifyError('Die Zusatzleistungen konnten nicht geladen werden! Server error!');
                }
            })
        }
    },


    watch: {
        placeholderInfo: {
            handler: function (newValue, oldValue) {
                if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
                    this.otherServiceTypeSearch(this.queryString, true);
                }
            },
            deep: true
        },


        value: {
            handler: function (newValue, oldValue) {
                if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
                    this.otherServiceTypeSelected = JSON.parse(JSON.stringify(this.value));
                }
            },
            deep: true,
            immediate: true
        },


        otherServiceTypeSelected: {
            handler: function (value) {
                this.$emit('input', value);
            },
            deep: true
        }
    },


    components: {
        Multiselect
    }
}
</script>
